import type { FC } from 'react';

import type { LelandImage } from '../../types/cmsTypes';
import SanityImage from '../image/SanityImage';

interface Props {
  className?: string;
  image: LelandImage;
}

const ArticleHeroImage: FC<Props> = ({ className, image }) => {
  return (
    <div className={`${className} relative aspect-[3/2] w-full lg:w-50%`}>
      <SanityImage
        className="object-cover"
        image={image}
        fill
        sizes={{ dflt: '90vw' }}
        alt=""
        priority
      />
    </div>
  );
};

export default ArticleHeroImage;
